import {
  Box,
  Button,
  Divider,
  IconButton,
  InputAdornment,
  Paper,
  styled,
  TextField,
  Typography,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import DisabledByDefaultIcon from '@mui/icons-material/DisabledByDefault';
import React, {
  ChangeEvent,
  useEffect,
  useRef,
  useState,
  SetStateAction,
  Dispatch,
} from 'react';
import { QueryCache, useMutation, useQuery, useQueryClient } from 'react-query';

const NoImagePaper = styled(Paper)({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  color: '#C2CAD4',
  padding: '1.5rem',
  margin: '1rem 0',
  cursor: 'pointer',
});

const NoImageIcon = styled(AddOutlinedIcon)({
  border: '1px dashed #C2CAD4',
  borderRadius: '50%',
  width: '3em',
  height: 'auto',
});

interface Props {
  src: string;
  onDelete: () => void;
  width?: string;
  height?: string;
}

export const SwImageBox: React.FC<Props> = ({
  src,
  onDelete,
  width = '10rem',
  height = 'auto',
}) => {
  const [id, setId] = useState<string>('');
  const [title, setTitle] = useState<string>('');

  return (
    <>
      {src ? (
        <Box sx={{ position: 'relative' }}>
          <img
            src={src}
            alt=''
            style={{
              width: '12rem',
              height: '12rem',
              padding: '.5rem',
              margin: '0rem 0',
            }}
          />
          <Button
            sx={{ position: 'absolute', top: '1%', right: '-20%' }}
            onClick={() => {
              onDelete();
            }}
          >
            <DisabledByDefaultIcon sx={{ color: '#000000' }} />
          </Button>
        </Box>
      ) : (
        <NoImagePaper
          aria-hidden
          onClick={() => {
            onDelete();
          }}
          sx={{ width: width }}
        >
          <NoImageIcon />
          <Typography sx={{ fontSize: '.75rem' }}>이미지 선택</Typography>
        </NoImagePaper>
      )}
    </>
  );
};
